export const componentTheme = {
  button: {
    colorScheme: {
      light: {
        outlined: {
          primary: {
            color: '{ganzimmun.darkBlue}'
          }
        },
        text: {
          primary: {
            color: '{ganzimmun.darkBlue}'
          }
        },
        link: {
          color: '{ganzimmun.darkBlue}',
          hoverColor: '{primary.950}',
          activeColor: '{ganzimmun.black}'
        }
      }
    }
  },
  datatable: {
    colorScheme: {
      light: {
        row: {
          selected: {
            color: '{datatable.row.color}'
          }
        }
      }
    }
  },
  select: {
    colorScheme: {
      light: {
        option: {
          selected: {
            color: '{select.color}',
            focus: {
              color: '{select.color}'
            }
          }
        }
      }
    }
  }
}
